import { createFileRoute } from '@tanstack/react-router';

import { CitationBrowse } from '@/module/Author/Citation/CitationBrowse';

export const Route = createFileRoute('/_auth/author/_author/article/_article/$articleId/_layout/citations/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { articleId } = Route.useParams();
  return <CitationBrowse publicationId={articleId} />;
}
